import { Loader } from '@googlemaps/js-api-loader';
import { loadGoogleMapsApi, getGoogleMapsApiKey } from '../utils/googleMaps';

// Re-export the loadGoogleMapsApi function from our utils
export { loadGoogleMapsApi } from '../utils/googleMaps';

// Create a loader instance for components that specifically need the Loader
export const googleMapsLoader = new Loader({
  apiKey: getGoogleMapsApiKey(),
  version: 'weekly',
  libraries: ['places', 'geometry', 'drawing'],
  region: 'AU',
  language: 'en',
});

// This function now uses our optimized loader from googleMaps.ts
export async function loadGoogleMaps(): Promise<void> {
  return loadGoogleMapsApi();
}

// Check if Google Maps is loaded
export function isGoogleMapsLoaded(): boolean {
  return typeof window !== 'undefined' && 
         window.google !== undefined && 
         window.google.maps !== undefined;
} 